// Active-section state for the per-page section rail (.section-nav-container).
// Generic: top-level <main> blocks with an id pair with rail links via href="#id".
// Anchor jumps remain the no-JS fallback; this paints the active entry and
// smooth-scrolls rail clicks.
const railLinks = Array.from(document.querySelectorAll(".section-nav-link"));
const railBlocks = Array.from(document.querySelectorAll("main > [id]")).filter((el) =>
  railLinks.some((a) => a.getAttribute("href") === `#${el.id}`)
);
if (railLinks.length > 0 && railBlocks.length > 0) {
  let railTops = [];
  const measureRail = () => {
    const y = window.scrollY;
    railTops = railBlocks.map((el) => el.getBoundingClientRect().top + y);
  };
  const paintRail = () => {
    const line = window.scrollY + window.innerHeight * 0.4;
    let id = railBlocks[0].id;
    railBlocks.forEach((el, i) => {
      if (railTops[i] <= line) id = el.id;
    });
    railLinks.forEach((a) => {
      const on = a.getAttribute("href") === `#${id}`;
      a.classList.toggle("is-active", on);
      if (on) a.setAttribute("aria-current", "true");
      else a.removeAttribute("aria-current");
    });
  };
  let railTicking = false;
  window.addEventListener(
    "scroll",
    () => {
      if (railTicking) return;
      railTicking = true;
      requestAnimationFrame(() => {
        railTicking = false;
        paintRail();
      });
    },
    { passive: true }
  );
  window.addEventListener("resize", () => {
    measureRail();
    paintRail();
  });
  window.addEventListener("load", () => {
    measureRail();
    paintRail();
  });
  // Smooth-scroll on rail clicks. Native smooth scrolling (CSS scroll-behavior /
  // scrollIntoView options) did not glide reliably, so animate the scroll here
  // with rAF (~600ms ease-out); plain anchor jumps remain the no-JS fallback.
  // A manual wheel/touch scroll cancels a running glide.
  let railGlide = 0;
  const RAIL_LANDING_GAP = 48; // px of air left above the section after the glide
  const cancelRailGlide = () => cancelAnimationFrame(railGlide);
  const glideToRail = (target) => {
    cancelRailGlide();
    const fromY = window.scrollY;
    // Land slightly above the section so it arrives with air above it.
    const destination = Math.max(0, target.getBoundingClientRect().top + fromY - RAIL_LANDING_GAP);
    const distance = destination - fromY;
    if (distance === 0) return;
    const start = performance.now();
    const duration = 600;
    const stepRail = (now) => {
      const t = Math.min((now - start) / duration, 1);
      window.scrollTo(0, fromY + distance * (1 - Math.pow(1 - t, 3)));
      if (t < 1) railGlide = requestAnimationFrame(stepRail);
    };
    railGlide = requestAnimationFrame(stepRail);
  };
  window.addEventListener("wheel", cancelRailGlide, { passive: true });
  window.addEventListener("touchstart", cancelRailGlide, { passive: true });
  railLinks.forEach((a) => {
    a.addEventListener("click", (event) => {
      const target = document.querySelector(a.getAttribute("href"));
      if (target) {
        event.preventDefault();
        glideToRail(target);
        try {
          history.replaceState(null, "", a.getAttribute("href"));
        } catch {
          // Hash update is a nicety; the glide must not depend on it.
        }
      }
    });
  });
  measureRail();
  paintRail();
}
